// jscpd:ignore-start
import Controller from '@ember/controller';
import QueryParams from 'eflex/constants/bi-query-params';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { andonReports } from 'eflex/constants/bi-report-options';
import moment from 'moment-timezone';

export default class BiProductionController extends Controller {
  @tracked drawerCollapsed = false;
  @tracked userIds = [];
  @tracked modelIds = [];
  @tracked stationIds = [];
  @tracked tags = [];
  @tracked shiftNames = [];
  @tracked beginDate = moment().startOf('day').toISOString();
  @tracked endDate = moment().endOf('day').toISOString();
  @tracked useTotalCycles = false;
  @tracked selectedToken;
  @tracked refresher = false;

  queryParams = Object.keys(QueryParams);
  selectedReport = andonReports.partCounts;

  get reportOptions() {
    return Object.values(andonReports);
  }

  @action
  onSearch(params) {
    this.resetCriteria();
    Object.assign(this, params);
  }

  @action
  resetCriteria() {
    Object.assign(this, {
      userIds: [],
      modelIds: [],
      stationIds: [],
      tags: [],
      shiftNames: [],
      beginDate: null,
      endDate: null,
      useTotalCycles: false,
    });
  }

  @action
  refresh() {
    this.refresher = true;
  }
  // jscpd:ignore-end
}
